/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    background: { type: 'variant', values: [ true ] },
    color: {
      type: 'variant',
      values: [
        'brand',   'subtle',
        'offer',   'success',
        'danger',  'warning',
        'inverse', 'default'
      ]
    },
    padding: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
    },
    rank: { type: 'variant', values: [ 'primary' ] },
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'large', 'extraLarge' ]
    },
    style: {
      type: 'variant',
      values: [ 'default', 'brand', 'dark', 'light' ]
    }
  },
  rules: [
    { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
    { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
    { if: { padding: 'medium' }, tokens: { padding: 4, width: 16 } },
    { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
    {
      if: { padding: 'extraLarge' },
      tokens: { padding: 4, width: 32 }
    },
    {
      if: { background: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 8
      }
    },
    {
      if: { background: true, padding: 'micro' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 4
      }
    },
    {
      if: { background: true, padding: 'small' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 8
      }
    },
    {
      if: { background: true, padding: 'medium' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 16
      }
    },
    {
      if: { background: true, padding: 'large' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 24
      }
    },
    {
      if: { background: true, padding: 'extraLarge' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderRadius: 45,
        padding: 4,
        width: 32
      }
    },
    {
      if: { style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'micro', style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'small', style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'medium', style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'large', style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'extraLarge', style: 'default' },
      tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'micro', style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'small', style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'medium', style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'large', style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'extraLarge', style: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
    },
    {
      if: { padding: 'micro', style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'small', style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'medium', style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'large', style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'extraLarge', style: 'dark' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'micro', style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'small', style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'medium', style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'large', style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    {
      if: { padding: 'extraLarge', style: 'light' },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 45,
        padding: 4
      }
    },
    { if: { size: 'micro' }, tokens: { size: 16 } },
    { if: { size: 'small' }, tokens: { size: 20 } },
    { if: { size: 'large' }, tokens: { size: 32 } },
    { if: { size: 'extraLarge' }, tokens: { size: 48 } },
    { if: { color: 'brand' }, tokens: { color: '#4b286d' } },
    { if: { color: 'default' }, tokens: { color: '#414547' } },
    { if: { color: 'subtle' }, tokens: { color: '#676e73' } },
    { if: { color: 'success' }, tokens: { color: '#2b8000' } },
    { if: { color: 'danger' }, tokens: { color: '#c12335' } },
    { if: { color: 'warning' }, tokens: { color: '#c77539' } },
    { if: { color: 'inverse' }, tokens: { color: '#ffffff' } },
    {
      if: { color: 'offer' },
      tokens: {
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    { if: { rank: 'primary' }, tokens: { color: '#4b286d' } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    color: '#414547',
    gradient: null,
    padding: 0,
    paddingTop: 0,
    scale: 1,
    size: 24,
    translateX: 0,
    translateY: 0,
    width: 0
  }
}
export default theme
